import Quill from "quill/dist/quill.js";
import ImageUploader from "./quill-image-uploader/src/quill.imageUploader.js";

window.Quill = Quill;

Quill.register("modules/imageUploader", ImageUploader);